import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Profile from './Profile';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ChangePassword from './ChangePassword';
import ChangeEmail from './ChangeEmail';

export class Dashboard extends Component {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map,
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const {session} = this.props;
        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.settings.headline.intro' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <Profile session={session}/>
                </Page.Section>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.profile.change_email.title' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <ChangeEmail />
                </Page.Section>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.profile.change_password.title' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <ChangePassword />
                </Page.Section>
            </Page.Body>
        );
    }
}

export default connect(state => ({
    session: state.session,
}))(Dashboard);
